import BaseService from "@/services/BaseService";
import { http } from "./config";

class NCMService extends BaseService {
  constructor() {
    super("/v1/ncm");
  }
  
  listar(data){
    const queryParams = `codigo=${data.codigo ? data.codigo : ''}
      &descricao=${data.descricao ? data.descricao : ''}
      &page=${data.page ? data.page : 1}
      &limit=${data.limit ? data.limit : ''}`

      return http.get(`/v1/ncm?${queryParams}`)
  }
  atualizarTabela() {
    return http.get("/v1/ncm-atualizar-tabela");
  }
}

export default new NCMService();
